import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';

// Ported from cc-shopping-client's LoadingSpinner (MUI -> Panda).
type LoadingSpinnerVariant = 'onPrimaryButton' | 'blue';
const VARIANT_CLASSES: Record<LoadingSpinnerVariant, {
  root: string;
  track: string;
  arc: string;
}> = {
  onPrimaryButton: {
    root: css({
      width: '[24px]',
      height: '[24px]'
    }),
    track: css({
      color: 'greens.light'
    }),
    arc: css({
      color: 'greens.lighter-2'
    })
  },
  blue: {
    root: css({
      width: '[20px]',
      height: '[20px]'
    }),
    track: css({
      color: 'blues.lighter'
    }),
    arc: css({
      color: 'blues.main'
    })
  }
};
const spinClass = css({
  flexShrink: '0',
  animation: 'spin 1s linear infinite'
});
type LoadingSpinnerProps = {
  variant: LoadingSpinnerVariant;
};
export function LoadingSpinner(t0) {
  const $ = _c(8);
  const {
    variant
  } = t0;
  const classes = VARIANT_CLASSES[variant];
  const t1 = `${spinClass} ${classes.root}`;
  let t2;
  if ($[0] !== classes.track) {
    t2 = <path className={classes.track} fill="currentColor" d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M4.27 12a7.73 7.73 0 1 0 15.46 0 7.73 7.73 0 0 0-15.46 0" />;
    $[0] = classes.track;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== classes.arc) {
    t3 = <path className={classes.arc} fill="currentColor" d="M21.836 18.875A12 12 0 0 0 7.79.763L9.287 4.76a7.73 7.73 0 0 1 9.05 11.668z" />;
    $[2] = classes.arc;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <svg aria-hidden="true" data-testid="loading-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className={t1}>{t2}{t3}</svg>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}